module.exports = __webpack_public_path__ + "img/15e7cfa.jpg";